<template>
  <BootstrapModal :show="showModal"
                  :title="this.schedule != null ? 'Plan bearbeiten' : 'Neuen Plan anlegen'"
                  :trigger-class=triggerClass :trigger-icon=triggerIcon
                  :trigger-text="triggerText" submit-btn="Speichern" @close="handleClose" @open="handleOpen"
                  @save="handleSave">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="startDate">Start-Datum</label>
          <input id="startDate" v-model="this.schedule.startDate" class="form-control" required type="date">
        </div>
        <div class="col">
          <label class="form-label" for="endDate">End-Datum</label>
          <input id="endDate" v-model="this.schedule.endDate" class="form-control" required type="date">
        </div>
        <div class="col">
          <label class="form-label" for="annotation">Anmerkung</label>
          <input id="annotation" v-model="this.schedule.annotation" class="form-control" type="text">
        </div>
        <div class="col">
          <label class="form-label" for="altarServers">Messdiener</label>
          <div class="btn-group btn-group-sm" role="group">
            <button class="btn btn-primary" type="button" @click.stop="bulkAddAltarServersToSchedule(false)"><em
                class="align-middle material-icons">done_all</em>Alle hinzufügen
            </button>
            <button class="btn btn-primary" type="button" @click.stop="bulkAddAltarServersToSchedule(true)"><em
                class="align-middle material-icons">rule</em>Aktive hinzufügen
            </button>
            <button class="btn btn-danger" type="button" @click.stop="bulkRemoveAltarServersFromSchedule"><em
                class="align-middle material-icons">delete</em>Alle entfernen
            </button>
          </div>
          <multiselect id="altarServers" v-model="this.schedule.altarServers" :close-on-select="false"
                       :custom-label="this.altarServerStore.getPlannameById"
                       :multiple="true" :options="this.altarServerStore.getIDs"
                       class="form-control list-group-item" required>
          </multiselect>
        </div>
        <div class="col">
          <label class="form-label" for="masses">Messen</label>
          <div class="btn-group btn-group-sm" role="group">
            <button class="btn btn-primary" type="button" @click.stop="bulkAddMassesToSchedule(false)"><em
                class="align-middle material-icons">done_all</em>Alle passenden hinzufügen
            </button>
            <button class="btn btn-danger" type="button" @click.stop="bulkRemoveMassesFromSchedule"><em
                class="align-middle material-icons">delete</em>Alle entfernen
            </button>
          </div>
          <multiselect id="" v-model="this.schedule.mass_set" :close-on-select="false"
                       :custom-label="this.massStore.getMassStringById"
                       :multiple="true" :options="this.massStore.getIDs"
                       class="form-control list-group-item" required>
          </multiselect>
        </div>
        <div class="col" style="flex: 0 0 100%; max-width: 100%;">
          <label class="form-label">Dienst-Limits (optional)</label>
          <div v-for="(row, index) in limitRows" :key="index" class="d-flex align-items-center gap-2 mb-1">
            <multiselect v-model="row.altarServer" :custom-label="this.altarServerStore.getPlannameById"
                         :options="availableLimitServers(row.altarServer)" placeholder="Messdiener wählen"
                         style="max-width: 20rem;"></multiselect>
            <input v-model.number="row.maxServings" class="form-control form-control-sm" min="1"
                   placeholder="Max. Dienste" style="width: 8rem;" type="number">
            <button class="btn btn-sm btn-outline-danger" type="button" @click.stop="removeLimitRow(index)"><em
                class="align-middle material-icons">remove</em></button>
          </div>
          <button class="btn btn-sm btn-primary" type="button" @click.stop="addLimitRow"><em
              class="align-middle material-icons">add</em>Limit hinzufügen
          </button>
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "@/components/BootstrapModal";
import Multiselect from "vue-multiselect";
import {useAltarServerStore} from "@/stores/altarServer";
import {useMassStore} from "@/stores/mass";
import {useScheduleStore} from "@/stores/schedule";

export default {
  name: "ScheduleCreateEditModal",
  props: ['passInSchedule', 'triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      schedule: {},
      limitRows: [],
      showModal: false,
    }
  },
  methods: {
    handleOpen() {
      this.showModal = true;
      this.schedule = this.passInSchedule == null ? {} : this.passInSchedule;
      this.limitRows = (this.schedule.server_limits || [])
          .map(limit => ({altarServer: limit.altarServer, maxServings: limit.maxServings}));
    },
    handleClose() {
      this.showModal = false;
      this.schedule = {};
      this.limitRows = [];
    },
    handleSave() {
      this.schedule.server_limits = this.limitRows
          .filter(row => row.altarServer != null && row.maxServings)
          .map(row => ({altarServer: row.altarServer, maxServings: row.maxServings}));
      if (this.schedule.id == null)
        this.scheduleStore.addItem(this.schedule);
      else
        this.scheduleStore.updateItem(this.schedule);
      this.handleClose();
    },
    addLimitRow() {
      this.limitRows.push({altarServer: null, maxServings: null});
    },
    removeLimitRow(index) {
      this.limitRows.splice(index, 1);
    },
    availableLimitServers(current) {
      const used = this.limitRows.map(row => row.altarServer).filter(id => id !== current);
      return (this.schedule.altarServers || []).filter(id => !used.includes(id));
    },
    bulkAddAltarServersToSchedule(onlyActive) {
      if (onlyActive)
        this.schedule.altarServers = this.altarServerStore.getActiveAltarServersIDs;
      else
        this.schedule.altarServers = this.altarServerStore.getIDs;
    },
    bulkRemoveAltarServersFromSchedule() {
      this.schedule.altarServers = [];
    },
    bulkAddMassesToSchedule() {
      if (this.schedule.startDate && this.schedule.endDate)
        this.schedule.mass_set = this.massStore.getMassIdsInPeriod(this.schedule.startDate, this.schedule.endDate);
    },
    bulkRemoveMassesFromSchedule() {
      this.schedule.mass_set = [];
    },
  },
  components: {BootstrapModal, Multiselect},
  setup() {
    const altarServerStore = useAltarServerStore();
    const massStore = useMassStore();
    const scheduleStore = useScheduleStore();
    return {altarServerStore, massStore, scheduleStore};
  },
  created() {
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
    if (!this.massStore.loadedData)
      this.massStore.getData();
    if (!this.scheduleStore.loadedData)
      this.scheduleStore.getData();
  }
}
</script>
